import { createActions, createReducer } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["transportId", "data", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "REQUEST_RESCHEDULING_" }
);

export interface RequestReschedulingState extends IState {}

const INITIAL_STATE: RequestReschedulingState = {
  loading: false,
  error: null,
};

const request = (state: RequestReschedulingState) =>
  update(state, { loading: { $set: true }, error: { $set: null } });

const success = (state: RequestReschedulingState, _action: ISuccessAction) =>
  update(state, { loading: { $set: false } });

const failure = (state: RequestReschedulingState, action: IFailureAction) =>
  update(state, { loading: { $set: false }, error: { $set: action.error } });

export const requestRescheduling = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: () => INITIAL_STATE,
});

export const RequestReschedulingTypes = Types;
export const RequestReschedulingActions = Creators;
